export const file = () => (
  <path
    d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8m-6-6l6 6m-6-6v6h6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
